export const formatCardMask = (lastDigit: string) => {
  return `**** **** **** ${lastDigit}`;
};

export const nequiMask = (accountNumber: string) => {
  // if the account number is not 10 digits long, return the original number
  if (accountNumber.length !== 10) {
    return accountNumber;
  }

  // display the account number in the format XXX XXX XXXX
  const formattedNumber = `${accountNumber.slice(0, 3)} ${accountNumber.slice(3, 6)} ${accountNumber.slice(6)}`;

  return formattedNumber;
};

export const formatPhoneNumber = (number: string) => {
  const match = number.match(/^(\d{2})(\d{3})(\d{3})(\d{4})$/);
  return match ? `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}` : number;
};

export const formatGiftCard = (value: string): string => {
  const formattedValue = value.toString().replace(/(.{5})/g, "$1-");

  if (formattedValue.slice(-1) === "-") {
    return formattedValue.slice(0, -1);
  }
  return formattedValue;
};
